// extracted by mini-css-extract-plugin
export default {"autoComplete":"mS-z","error":"nS-z","disabled":"oS-z"};